import React, { memo, useEffect } from "react";
import styles from "./ProjectIndex.module.css";
import Container from "@material-ui/core/Container";
import { motion, AnimatePresence } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../root/RootReducer";
import TimelineBar from "../../../chronology/components/TimelineBar";
import {
    Avatar,
    Button,
    CircularProgress,
    createStyles,
    makeStyles,
    Theme,
} from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { changeMenu } from "../../../../root/components/layout/header/HeaderActions";
import { resetfilter } from "../../../../common/video/VideoFilterActions";
import { filterUserList } from "../../../../presenters/PresentersActions";
import { filterProjectList } from "../../../../store/actions/ExProjectActions";
// import { filterVideoList } from "../../../../common/video/VideoActions";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        pTag: {
            marginRight: theme.spacing(3),
            marginTop: theme.spacing(1),
            cursor: "pointer",
            borderRadius: "0.7em",
            height: 52,
            fontSize: 18,
        },
        tag: {
            marginRight: theme.spacing(3),
            marginTop: theme.spacing(1),
            cursor: "pointer",
            borderRadius: "2em",
            height: 50,
            fontSize: 18,
        },
        delIcon: {
            marginLeft: theme.spacing(1),
            fontSize: "30px",
        },
        projectIcon: {
            marginRight: theme.spacing(1),
            marginLeft: theme.spacing(-1),
        },
        filterProfile: {
            width: theme.spacing(6),
            height: theme.spacing(6),
            marginRight: theme.spacing(1),
            marginLeft: theme.spacing(-1),
            backgroundColor: "white",
        },
        msg: {
            marginTop: "65px",
        },
    })
);

function ProjectIndex() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { projectList, isLoading } = useSelector(({ exProject }: AppState) => exProject);
    const [isFiltered, setIsFiltered] = React.useState(false);

    const { videoFilter } = useSelector((state: AppState) => ({
        videoFilter: state.videoFilter.videoFilters,
    }));

    const { users, userInfo } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
        users: state.presenters.index.filteredUsers,
    }));

    //APIコール
    useEffect(() => {
        if (userInfo) {
            dispatch(filterProjectList(userInfo.id, videoFilter.id));
            dispatch(filterUserList({ id: parseInt(userInfo.id), skill: [], tag: [] }));
        }
        if (videoFilter.professional.length > 0) {
            setIsFiltered(true);
        } else {
            // dispatch(GetAllProjectList());
            setIsFiltered(false);
        }
    }, [dispatch, videoFilter, userInfo]);

    const { header } = useSelector((state: AppState) => ({
        header: state.header,
    }));
    const direction = header.direction === "left" ? -1 : 1;

    const delfilter = (item: string) => {
        const professionalFilter = {
            ...videoFilter,
            id: [],
            professional: videoFilter.professional.filter((i) => i !== item),
        };

        dispatch(resetfilter(professionalFilter));
        dispatch(changeMenu(header.from, header.to, "same"));
    };

    if (isLoading) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    return (
        <>
            <Container maxWidth="xl">
                <AnimatePresence>
                    <motion.div
                        key="projectIndex"
                        initial={{ x: 300 * direction, opacity: 0.3 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: -300 * direction, opacity: 0 }}
                        className={styles.root}
                    >
                        <div className={isFiltered ? styles.filter : ""}>
                            {videoFilter.professional.map((professional, index) => (
                                <Button
                                    key={`${index}`}
                                    size="large"
                                    variant="outlined"
                                    className={classes.pTag}
                                >
                                    <Avatar
                                        className={classes.filterProfile}
                                        src={
                                            users
                                                ? process.env.REACT_APP_API_ENDPOINT +
                                                  users[0].imageUrl
                                                : ""
                                        }
                                    />
                                    {professional}
                                    <HighlightOffIcon
                                        color="action"
                                        className={classes.delIcon}
                                        onClick={() => delfilter(professional)}
                                    />
                                </Button>
                            ))}
                        </div>
                        <div className={isFiltered ? styles.projectArea : ""}>
                            <TimelineBar projectList={projectList} />
                        </div>
                    </motion.div>
                </AnimatePresence>
            </Container>
        </>
    );
}

export default memo(ProjectIndex);
